export { PanCancerModule } from './pan-cancer.module';
